import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useIsEditing = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post(`/Sheet/IsEditingSheet?sheetId=${formData.sheetId}&userId=${formData.userId}`);
  });
  return mutation;
};

export default useIsEditing;